import { Box, styled } from '@mui/material';

type RoundedIconWrapperContainerType = {
  iconColor: string;
  borderColor: string;
  backgroundColor: string;
  itemValue: string | number;
  isCanEdit?: boolean;
  isSmall?: boolean;
  noneValue?: string | number;
  isBig?: boolean;
  hiddenBackground?: boolean;
  customTagSize?: string;
};
export const RoundedIconWrapperContainer = styled(Box, {
  shouldForwardProp: (prop: string) =>
    ![
      'iconColor',
      'borderColor',
      'backgroundColor',
      'itemValue',
      'isCanEdit',
      'isSmall',
      'isBig',
      'noneValue',
      'hiddenBackground',

      'customTagSize',
    ].includes(prop),
})<RoundedIconWrapperContainerType>(
  ({
    iconColor,
    borderColor,
    backgroundColor,
    itemValue,
    isSmall,
    isBig,
    noneValue,
    hiddenBackground,
    customTagSize,
  }) => ({
    width: isBig ? '36px' : isSmall ? '20px' : '24px',
    height: isBig ? '36px' : isSmall ? '20px' : '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: `1px ${itemValue === noneValue ? 'dashed' : 'solid'} ${borderColor}`,
    backgroundColor: backgroundColor,
    borderRadius: '50%',

    svg: {
      width: isBig ? '20px' : isSmall ? '12px' : '16px',
      height: isBig ? '20px' : isSmall ? '12px' : '16px',
      path: {
        fill: iconColor,
      },
    },
    ...(hiddenBackground && {
      border: 'none',
      backgroundColor: 'none',
    }),
    ...(customTagSize && {
      svg: {
        width: customTagSize,
        height: customTagSize,
        path: {
          fill: iconColor,
        },
      },
    }),
  }),
);
